import { toast } from 'react-toastify';

/**
 * Fetch helper for multipart/form-data uploads (files)
 * Similar to fetchWithAuth but doesn't set Content-Type (browser sets it with boundary)
 */
export async function fetchWithFormData(
  input: RequestInfo,
  formData: FormData,
  method: string = 'POST',
  { notifyOnError = true }: { notifyOnError?: boolean } = {}
) {
  const token = localStorage.getItem('jwt');

  try {
    const response = await fetch(`${process.env.REACT_APP_API_URL}${input}`, {
      method,
      headers: {
        Authorization: `Bearer ${token}`,
        "ngrok-skip-browser-warning": "monkey"
        // NO Content-Type header - browser will set it automatically with boundary
      },
      body: formData, // Send FormData directly
    });

    if (response.status === 401) {
      localStorage.removeItem('jwt');
      window.location.href = '/login';
    }

    if (!response.ok && notifyOnError) {
      const errorData = await response.clone().json().catch(() => ({}));
      const errorMessage = errorData.errors?.[0] || 'An error occurred';
      toast.error(errorMessage);
    }

    return response;
  } catch (err) {
    toast.error('Network error');
    throw err;
  }
}
